import React, { Component } from "react";
import { Form} from 'semantic-ui-react';
import  Logo  from "./logo";
import api from "../core/api";
import { logout } from "../core/auth";
import trocaSenhaImg from "../img/troca-senha.png";
import { isUndefined } from "util";
import formatError from "../js/formatError"

class Termo extends Component {

  constructor(props){
    super(props);
    
    this.state = {
      error: isUndefined(this.props.history.location.state) || isUndefined(this.props.history.location.state.passo)?"Você deve passar por todo o fluxo da troca de senha.":null,
      passo: isUndefined(this.props.history.location.state)?false:!isUndefined(this.props.history.location.state.passo),
      aceito:false,
      url_posic:"",
      textoPosic:"",
    }
    this._buscaUrl();
  }

  _buscaUrl() {
    api.get("/buscarUrlPosic",{}) 
      .then(res => {
          this.setState({
            url_posic: res.data
          });
        }
      )
      .catch(err => {
        formatError(err.response, this, "Verifique o parâmetro de sistema: P_URL_GEO_POSIC.");
        }
      );
      
      api.get("/buscarTextoPosic") 
      .then(res => {
          this.setState({
            textoPosic: res.data
          });
        }
      )
      .catch(err => {
        formatError(err.response, this, "Verifique o parâmetro se sistema: P_TERMO_RESP_POSIC.");
        }
      );
  }


  _data() {
    const data = new Date();
    const meses = ["janeiro","fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro","novembro", "desembro"];
    return data.getDate() + " de " + meses[data.getMonth()] + " de " + data.getFullYear() ;
  }

  handleCancelar = async e => {
    if(window.confirm("Atenção: Tem certeza que deseja cancelar a troca de sua senha?")) {
      logout();
      this.props.history.push("/");
    }
  }

  handleAceite = async e =>  {
    e.preventDefault();
    this.setState({aceito: "true"});
    window.open(this.state.url_posic,"_Blank");
  }

  handleConfirmar = async e => {
    e.preventDefault();
    this.props.history.push("/troca", {passo:3});
  }

  render() {
    if(!this.state.passo) {
      this.props.history.push("/");
    }
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <h5 className="card-title text-center margin-top">
              <img src={trocaSenhaImg} className="img-responsive troca-senha" alt="Confirmação de Dados" />
            </h5>
            <p>Termo de Responsabilidade</p>
              {this.state.error && <div className="msgError center">{this.state.error}</div>}
            <h1>{this.state.textoPosic}</h1>
            <Form action="/">
              <button className="btn btn-secondary btn-block" type="button" onClick={this.handleAceite}>
                  Leia a POSIC e o Cód. Conduta do HCPA.
              </button>
              <br />

              <button id="btnConfirmar"
                className="btn btn-primary btn-block margin-top-input text-uppercase" 
                type="submit" 
                onClick={this.handleConfirmar}
                disabled={this.state.aceito!=="true"}
                >
                Confirmo o Aceite
              </button>
              <button id="btnCancelar" className="btn btn-secondary btn-block text-uppercase" type="button" onClick={this.handleCancelar}>Cancelar</button>
              <p className="text-center">{this._data()}</p>
            </Form>
            <Logo />
          </div>
        </div>
      </div>
    );
  }
}

export default Termo;
